import { useEffect, useState } from 'react';

import type { AuthMachine } from './auth.machine';
import { AuthState } from './auth.machine';

export const createUseAuth = (authMachine: AuthMachine) => () => {
  const [state, setState] = useState(authMachine.state.getValue());
  const [context, setUser] = useState(authMachine.context.getValue());

  useEffect(() => {
    const subscriber = authMachine.state.subscribe(setState);

    return () => {
      subscriber.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const subscriber = authMachine.context.subscribe(setUser);

    return () => {
      subscriber.unsubscribe();
    };
  }, []);

  return {
    ...context,
    ...authMachine.actions,
    state,
    authenticated: state === AuthState.authenticated,
    mfaRequired: state === AuthState.mfaRequired,
    verificationRequired: state === AuthState.verificationRequired,
  };
};
